module.exports = __webpack_public_path__ + "static/media/mobile-8-1.31b9c741.svg";